export enum PaymentOrderStatusEnum {
  Failed = "FAILED",
  Pending = "PENDING",
  Posted = "POSTED",
}
